import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::deleteMethod
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/delete/{supplier_order}'
*/
export const deleteMethod = (args: { supplier_order: string | number } | [supplier_order: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/supplier-order/delete/{supplier_order}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::deleteMethod
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/delete/{supplier_order}'
*/
deleteMethod.url = (args: { supplier_order: string | number } | [supplier_order: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: args.supplier_order,
    }

    return deleteMethod.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::deleteMethod
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/delete/{supplier_order}'
*/
deleteMethod.delete = (args: { supplier_order: string | number } | [supplier_order: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::undo
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/{id}/undo-delete'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/supplier-order/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::undo
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/{id}/undo-delete'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::undo
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/{id}/undo-delete'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SupplierOrder\DeleteSupplierOrderController::undo
* @see app/Http/Controllers/SupplierOrder/DeleteSupplierOrderController.php
* @route '/api/supplier-order/{id}/undo-delete'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteSupplierOrderController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteSupplierOrderController